// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3iP_G","title":"AfterFrontImage_title__2_bBA"};